import React, { useEffect, useState, useCallback, useRef } from "react";

import { Link } from "react-router-dom";

import { ethers } from "ethers";
import { useAccount, useSigner, useProvider, useNetwork } from "wagmi";

import {
  VALIDATOR_ADDRESS,
  VALIDATOR_ABI,
  POS_NFT_ADDRESS,
  POS_NFT_ABI,
  STETH_ADDRESS,
  STETH_ABI,
} from "../../config/configValidator.js";

import {
    burnValidator,
    getValidatorOwner,
    isValidatorBurnApproved,
    getValidatorBalance,
    approveBurnValidator,
    isValidatorActive,
} from "../../helpers/validatorHelpers.js";

import "./style.css";
import {
    Grid,
    useMediaQuery,
    Input,
    Button,
    Modal,
    TextField,
    CircularProgress,
    Snackbar,
    Stack,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
// import { listAnimeSpiritsHeroesOfOwner_separate } from "../../helpers/mergerHelpers.js";
import Fade from "@mui/material/Fade";

import validatorImage from "../../assets/Validator_PSD_V3_web.png";
import validatorTitle from "../../assets/Validator_title_V0.png";

const Validator = () => {
    //wagmi hooks for account, signer, provider and network
    let { address, isConnected } = useAccount();
    const provider = useProvider();

    const targetTimestamp = 1700502335;
    
    const { data: signer, isError, isLoading } = useSigner();
    const {chain} = useNetwork()

    const matchesExtraLarge = useMediaQuery("(max-width:1600px)");
    const matchesLarge = useMediaQuery("(max-width:1500px)");
    const matchesMedium = useMediaQuery("(max-width:1200px)");
    const matchesSmall = useMediaQuery("(max-width:1024px)");
    const matchesMobile = useMediaQuery("(max-width:600px)");

    const [isChainSupported, setIsChainSupported] = useState(false)

    const [validatorOpen, setValidatorOpen] = useState(true);

    const [validatorOwner, setValidatorOwner] = useState(null);
    const [isValidatorActive, setIsValidatorActive] = useState(true);
    const [isBurnActive, setIsBurnActive] = useState(false);
    const [isBurnApproved, setIsBurnApproved] = useState(false);

    const [isBurnModalOpen, setIsBurnModalOpen] = useState(false);
    const [isBurnLoading, setIsBurnLoading] = useState(false);
    const [isBurnConfirmed, setIsBurnConfirmed] = useState(false);
    const [isBurnApprovedLoading, setIsBurnApprovedLoading] = useState(false);

    // CONTRACTS

    const [validatorContract, setValidatorContract] = useState(null);
    const [posNftContract, setPosNftContract] = useState(null);
    const [stETHContract, setStETHContract] = useState(null);

    const [openCelebrationModal, setOpenCelebrationModal] = useState(false);

    const [notification, setNotification] = useState({});


    // USE EFFECTS
    useEffect(() => {
        //STYLE
        document.body.style.background = ` linear-gradient(rgba(0,0,0,0.9),rgba(0,0,0,0.9)), url(${validatorImage})`;
        document.body.style.backgroundAttachment = "fixed";
        document.body.style.backgroundRepeat = "no-repeat";
        document.body.style.backgroundSize = "cover";
        document.body.style.backgroundColor = "#000000";
                
        return () => {
            document.body.style.background = "#111111";
            // Clear interval on component unmount
            // return () => clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        if (signer && address && provider && isChainSupported) {
            const validatorContract = new ethers.Contract(
                VALIDATOR_ADDRESS,
                VALIDATOR_ABI,
                signer
            );
            setValidatorContract(validatorContract);
            const posNftContract = new ethers.Contract(
                POS_NFT_ADDRESS,
                POS_NFT_ABI,
                signer
            );
            setPosNftContract(posNftContract);
            const stETHContract = new ethers.Contract(
                STETH_ADDRESS,
                STETH_ABI,
                signer
            );
            setStETHContract(stETHContract);
          

          // get validator owner
            const getValidatorOwnerFunction = async () => {
              if (posNftContract && signer && address && isChainSupported) { 
                  let validatorOwner_ = await getValidatorOwner(posNftContract);
                  setValidatorOwner(validatorOwner_);
                  // if validator owner is the current address, set burn active to true
                  // console.log("validatorOwner", validatorOwner_);

                  let isBurnApproved_ = await isValidatorBurnApproved(
                      address,
                      validatorContract,
                      posNftContract
                  );
                  setIsBurnApproved(isBurnApproved_);
                  // console.log("isBurnApproved", isBurnApproved_);
                  if (
                      validatorOwner_ &&
                      validatorOwner_.toLowerCase() === address.toLowerCase()
                  ) {
                      setIsBurnActive(true);
                  } else {
                      setIsBurnActive(false);
                  }
              }
              
            };
            getValidatorOwnerFunction();
          }

    }, [signer, address, provider, isChainSupported]);

    useEffect(() => {
      if (typeof chain !== "undefined" && typeof chain.unsupported !== "undefined") {
        setIsChainSupported(!chain.unsupported)
      }
      // console.log("chain changed", chain)
    }, [chain])

    const handleReload = () => {
      window.location.reload();
  };

  
    const handleCloseBurnModal = () => {
        setIsBurnModalOpen(false);
    }


    // const handleConfirmSacrifice = () => {
    //     setConfirmedSacrifice(true);
    // };

    const handleBurnValidator = () => {
      setIsBurnLoading(true);
      burnValidator(validatorContract)
        .then(() => {
          setIsBurnLoading(false);
          setOpenCelebrationModal(true);
          setNotification({
            state: true,
            message: "Validator succesfully burned",
            type: "success",
          });
        })
        .catch((err) => {
          setIsBurnLoading(false);
          setNotification({
            state: true,
            message: err.data ? err.data.message : err.message,
            type: "error",
          });
        });
    };

    const handleApproveBurnValidator = () => {
        setIsBurnApprovedLoading(true);
        approveBurnValidator(validatorContract, posNftContract)
            .then(() => {
                setIsBurnApproved(true);
                setIsBurnApprovedLoading(false);
                setNotification({
                    state: true,
                    message: "Succesfully approved",
                    type: "success",
                });
            })
            .catch((err) => {
                setIsBurnApproved(false);
                setIsBurnApprovedLoading(false);
                setNotification({
                    state: true,
                    message: err.data ? err.data.message : err.message,
                    type: "error",
                });
            });
    };

    // const handleApproveSacrifice = () => {
    //     setIsApproveLoading(true);
    //     approveSacrifice(wrapperContract, SACRIFICE_ADDRESS)
    //         .then(() => {
    //             setIsSacrificeApproved(true);
    //             setIsApproveLoading(false);
    //             setNotification({
    //                 state: true,
    //                 message: "Sacrifice contract succesfully approved",
    //                 type: "success",
    //             });
    //         })
    //         .catch((err) => {
    //             setIsApproveLoading(false);
    //             setIsSacrificeApproved(false);
    //             setNotification({
    //                 state: true,
    //                 message: err.data ? err.data.message : err.message,
    //                 type: "error",
    //             });
    //         });
    // };

    // const handleSacrificeTransaction = () => {
    //     setIsSacrificeLoading(true);

    //     // add 100000 to all selected spirits
    //     let selectedSpiritsToExp = selectedSpirits.map((spirit) => {
    //         return spirit + 100000;
    //     });
    //     spiritsToExp(sacrificeContract, selectedHero.id, selectedSpiritsToExp)
    //         .then(() => {
    //             // setSacrificeOpen(false);
    //             setOpenCelebrationModal(true);
    //             setIsSacrificeLoading(false);
    //             setNotification({
    //                 state: true,
    //                 message: "Sacrifice succesfully completed",
    //                 type: "success",
    //             });
    //         })
    //         .catch((err) => {
    //             setIsSacrificeLoading(false);
    //             setNotification({
    //                 state: true,
    //                 message: err.data ? err.data.message : err.message,
    //                 type: "error",
    //             });
    //         });
    // };

    // const handleCloseSacrifice = () => {
    //     setSacrificeOpen(false);
    //     setSelectedHero(null);
    //     setConfirmedSacrifice(false);
    //     setSelectedSpirits([]);
    //     setOpenCelebrationModal(false);
    //     handleReload();
    // };

    const handleDismissSnackBar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setNotification({ status: false });
    };
    return (
        <Grid
            container
            direction="column"
            justifyContent="start"
            alignItems="center"
            style={{
                paddingTop: "100px",
                width: "100%",
                height: "100%",
            }}
        >
            <Stack spacing={2} sx={{ width: "100%" }}>
                <Snackbar
                    autoHideDuration={2000}
                    open={notification.state && notification.type === "error"}
                    onClose={handleDismissSnackBar}
                    key={"error"}
                >
                    <MuiAlert
                        onClose={handleDismissSnackBar}
                        variant="filled"
                        severity="error"
                    >
                        {notification.message}
                    </MuiAlert>
                </Snackbar>
                <Snackbar
                    autoHideDuration={2000}
                    open={notification.state && notification.type === "success"}
                    onClose={handleDismissSnackBar}
                    key={"success"}
                >
                    <MuiAlert
                        onClose={handleDismissSnackBar}
                        variant="filled"
                        severity="success"
                    >
                        {notification.message}
                    </MuiAlert>
                </Snackbar>
            </Stack>
            <Modal
                disableScrollLock={true}
                style={{ border: "none" }}
                open={isBurnModalOpen}
                onClose={handleCloseBurnModal}
            >
                <Fade in={isBurnModalOpen}>
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: matchesMobile ? "100%" : "70%",
                            height: "auto",
                            padding: "40px 0",
                            maxHeight: "80%",
                            background: "#111111",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "start",
                            alignItems: "center",
                            borderRadius: "10px",
                            outline: "none",
                            // paddingTop: "25px",
                            color: "white",
                            overflowY: "auto",
                            overflowX: "hidden",
                        }}
                    >
                        {!openCelebrationModal && (
                            <div
                                style={{
                                    width: "90%",
                                    height: "100%",
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "start",
                                }}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "0px",
                                    }}
                                >
                                    {/* <Grid item xs={3}></Grid> */}
                                    {/* <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: matchesMobile
                                                ? "14px"
                                                : matchesSmall
                                                ? "16px"
                                                : "18px",
                                            textAlign: "center",
                                            color: "#ffb631",
                                        }}
                                    >
                                        FINALIZE BURN
                                    </Grid> */}
                                </Grid>
                                {!isBurnApproved && true && (
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        style={{
                                            width: "100%",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Grid item>
                                            <Button
                                                onClick={
                                                    handleApproveBurnValidator
                                                }
                                                style={{
                                                    background: "#ffb631",
                                                    color: "black",
                                                    width: "250px",
                                                    padding: "10px 0",
                                                    marginTop: "10px",
                                                    // margin: "10px 0",
                                                    borderRadius: 0,
                                                    fontSize: "16px",
                                                    fontFamily: "EurostilDemi",
                                                }}
                                                disabled={isBurnApproved}
                                            >
                                                {isBurnApprovedLoading ? (
                                                    <CircularProgress
                                                        size={28}
                                                    />
                                                ) : (
                                                    "1: APPROVE BURN"
                                                )}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )}
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "5px",
                                    }}
                                >
                                    {true && (
                                        <Grid item>
                                            <Button
                                                onClick={handleBurnValidator}
                                                style={{
                                                    background: isBurnApproved
                                                        ? "#ffb631"
                                                        : "rgba(255, 182, 49,0.5)",
                                                    color: "black",
                                                    width: "250px",
                                                    padding: "10px 0",
                                                    marginTop: "10px",
                                                    // margin: "10px 0",
                                                    borderRadius: 0,
                                                    fontSize: "16px",
                                                    fontFamily: "EurostilDemi",
                                                }}
                                                disabled={!isBurnApproved}
                                            >
                                                {isBurnLoading ? (
                                                    <CircularProgress
                                                        size={28}
                                                    />
                                                ) : isBurnApproved ? (
                                                    "1: BURN VALIDATOR"
                                                ) : (
                                                    "2: BURN VALIDATOR"
                                                )}
                                            </Button>
                                        </Grid>
                                    )}
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: "14px",
                                            textAlign: "center",
                                            // cursor: "pointer",
                                            color: "#ff4136",
                                            paddingTop: "20px",
                                            paddingBottom: "0px",
                                        }}
                                    >
                                        WARNING: THE VALIDATOR NFT WILL BE LOST
                                        FOREVER!
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                        {openCelebrationModal && (
                            <div
                                style={{
                                    width: "90%",
                                    height: "100%",
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "0px",
                                    }}
                                >
                                    {/* <Grid item xs={3}></Grid> */}
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: "22px",
                                            textAlign: "center",
                                            color: "#ffffff",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        THE VALIDATOR BURN WAS SUCCESSFUL <br />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: "22px",
                                            textAlign: "center",
                                            color: "#ffffff",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {/* {editionsToMint > 0 ? `+ ${editionsToMint} EDITION` : ""}{editionsToMint > 1 ? "S" : ""} */}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "EurostilNormal",
                                            fontSize: "15px",
                                            textAlign: "center",
                                            // italic
                                            fontStyle: "italic",
                                            color: "#ffffff",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {/* Talanji feasts on your Spirits, the echo of the ancestors resonates, <br/> soon illuminating the one who will inherit the ancient power. */}
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        // marginBottom: "10px",
                                    }}
                                ></Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Grid item>
                                        <Button
                                            onClick={handleCloseBurnModal}
                                            style={{
                                                background: "#ffb631",
                                                color: "black",
                                                width: "280px",
                                                padding: "10px 0",
                                                marginTop: "15px",
                                                // margin: "10px 0",
                                                borderRadius: 0,
                                                fontSize: "20px",
                                                fontFamily: "EurostilDemi",
                                            }}
                                        >
                                            {"CLOSE"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                    </div>
                </Fade>
            </Modal>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{
                    width: "100%",
                }}
            >
                <>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            width: "50%",
                            maxWidth: "600px",
                            // paddingTop: "25px",
                        }}
                    >
                        <img
                            style={{
                                width: "100%",
                                marginTop: "0px",
                                marginBottom: "20px",
                            }}
                            src={validatorTitle}
                        />
                    </div>

                    {/* <span
                        style={{
                            fontSize: matchesMobile
                                ? "20px"
                                : matchesMedium
                                ? "25px"
                                : matchesSmall
                                ? "20px"
                                : "32px",
                            fontFamily: "PPNeueMachina",
                            marginBottom: "5px",
                            fontWeight: "900",
                            color: "#ffb631",
                            letterSpacing: 6,
                        }}
                    >
                        VALIDATOR
                    </span> */}
                    <p
                        style={{
                            fontSize: matchesSmall ? "12px" : "14px",
                            // margin: "12px 0",
                            letterSpacing: 2,
                            fontWeight: 100,
                            width: matchesMobile ? "80%" : "50%",
                            fontFamily: "EurostilNormal",
                            whiteSpace: "pre-line",
                            textAlign: "center",
                            fontStyle: "italic",
                        }}
                    >
                        In the silence of the snowfields, the runes still hum.
                        Alone beneath dead stars, it stands: the First
                        Validator. Its engines do not sleep… for the chain must
                        not be broken.{" "}
                    </p>
                    {validatorOpen && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                width: "80%",
                                paddingTop: "25px",
                            }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="start"
                                style={{ width: "100%" }}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={6}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "start",
                                        alignItems: "start",
                                        width: "100%",
                                        // marginTop: "20px",
                                    }}
                                >
                                    <div className="videoContainer">
                                        <img
                                            style={{
                                                width: "100%",
                                                marginTop: "0%",
                                                cursor: "pointer", // Add cursor pointer to indicate it's clickable
                                            }}
                                            onClick={() =>
                                                window.open(
                                                    "https://leanime.mypinata.cloud/ipfs/QmXDomBkBn7nEWxGEn48ACe5hduSn7g8RwSqPxk4PmFDgS",
                                                    "_blank"
                                                )
                                            }
                                            src={validatorImage}
                                            alt="Validator" // Added alt text for accessibility
                                        />
                                    </div>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={6}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "100%",
                                            margin: "20px 0",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: matchesSmall
                                                    ? "20px"
                                                    : "22px",

                                                letterSpacing: 1,
                                                color: "#ffb631",
                                                fontWeight: 100,
                                                fontFamily: "PPNeueMachina",
                                            }}
                                        >
                                            {"THE OATH"}
                                        </span>{" "}
                                    </div>

                                    <div
                                        style={{
                                            padding: "10px",
                                            alignSelf: "start",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: matchesSmall
                                                    ? "14px"
                                                    : "16px",
                                                // letterSpacing: 1,
                                                // fontWeight: 100,
                                                fontFamily: "EurostilNormal",
                                                color: "#ffb631",
                                                marginBottom: "10px",
                                                marginLeft: "20px",
                                            }}
                                        >
                                            {
                                                "• The Validator is a unique 1/1 NFT, that mirrors the essence of an Ethereum Validator"
                                            }
                                        </span>
                                        <span
                                            style={{
                                                fontSize: matchesSmall
                                                    ? "14px"
                                                    : "16px",
                                                fontFamily: "EurostilNormal",
                                                // color: "#ffb631",
                                                marginBottom: "10px",
                                                marginLeft: "20px",
                                                // letterSpacing: 0.2,
                                            }}
                                        >
                                            {
                                                "• It controls a smart contract that contains 32 staked ETH (Lido stETH)"
                                            }
                                        </span>
                                        <span
                                            style={{
                                                fontSize: matchesSmall
                                                    ? "14px"
                                                    : "16px",
                                                fontFamily: "EurostilNormal",
                                                // color: "#ffb631",
                                                marginBottom: "10px",
                                                marginLeft: "20px",
                                            }}
                                        >
                                            {
                                                "• At any moment, the current owner may redeem all the stETH, offering the artwork as a final sacrifice."
                                            }
                                        </span>
                                        <span
                                            style={{
                                                fontSize: matchesSmall
                                                    ? "14px"
                                                    : "16px",
                                                fontFamily: "EurostilNormal",
                                                // color: "#ffb631",
                                                marginBottom: "10px",
                                                marginLeft: "20px",
                                            }}
                                        >
                                            {
                                                "• As time goes by, the value inside increases, making it more and more tempting to burn it..."
                                            }
                                        </span>
                                        <span
                                            style={{
                                                fontSize: matchesSmall
                                                    ? "14px"
                                                    : "16px",
                                                fontFamily: "EurostilNormal",
                                                // color: "#ffb631",
                                                marginBottom: "10px",
                                                marginLeft: "20px",
                                            }}
                                        >
                                            {
                                                "• Burning the NFT changes state of the artwork and relinquishes ownership forever."
                                            }
                                        </span>
                                        <span
                                            style={{
                                                fontSize: matchesSmall
                                                    ? "14px"
                                                    : "16px",
                                                fontFamily: "EurostilNormal",
                                                // color: "#ffb631",
                                                marginBottom: "10px",
                                                marginLeft: "20px",
                                            }}
                                        >
                                            {
                                                "• The artwork acts as both a guardian to the funds and a protector of the network."
                                            }
                                        </span>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "100%",
                                            margin: "20px 0",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: matchesSmall
                                                    ? "20px"
                                                    : "22px",

                                                letterSpacing: 1,
                                                color: "#ffb631",
                                                fontWeight: 100,
                                                fontFamily: "PPNeueMachina",
                                            }}
                                        >
                                            {"THE MERGE BLOCK"}
                                        </span>{" "}
                                    </div>
                                    <div
                                        style={{
                                            padding: "10px",
                                            alignSelf: "start",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: matchesSmall
                                                    ? "14px"
                                                    : "16px",
                                                fontFamily: "EurostilNormal",
                                                // color: "#ffb631",
                                                marginBottom: "10px",
                                                marginLeft: "20px",
                                            }}
                                        >
                                            {
                                                "• The NFT was purposely minted in 2022, "
                                            }
                                            <span
                                                style={{
                                                    color: "#ffb631",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                    window.open(
                                                        "https://etherscan.io/tx/0xf037c976a34578f42c88025cd51fcc358c510b4cec459af5462200305808a6d0",
                                                        "_blank"
                                                    )
                                                }
                                            >
                                                {
                                                    "in the first ever block of Proof of Stake"
                                                }
                                            </span>
                                            {
                                                ", a pivotal moment in blockchain history."
                                            }
                                        </span>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            width: "90%",
                                            alignItems: "center",
                                            justifyContent: "space-around",
                                        }}
                                    >
                                        {" "}
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                style={{ width: "100%" }}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        marginTop: "25px",
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button
                                        style={{
                                            background: "#ffb631",
                                            // background: "gray",
                                            color: "black",
                                            width: matchesMobile
                                                ? "80%"
                                                : "40%",
                                            padding: "25px 0",
                                            marginTop: "20px",
                                            // marginBottom: "50px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: 0,
                                            fontSize: "16px",
                                            fontFamily: "EurostilDemi",
                                        }}
                                        onClick={() => {
                                            // open https://opensea.io/item/ethereum/0xbabef83b0dd130e3519cc5eb8543a000e34bb034/1
                                            window.open(
                                                `https://opensea.io/item/ethereum/0xbabef83b0dd130e3519cc5eb8543a000e34bb034/1`,
                                                "_blank"
                                            );
                                        }}
                                    >
                                        <span>{"View on OpenSea"} </span>
                                    </Button>{" "}
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        marginTop: "5px",
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button
                                        style={{
                                            background:
                                                address &&
                                                isConnected &&
                                                isChainSupported &&
                                                isBurnActive
                                                    ? "#ffb631"
                                                    : "gray",
                                            // background: "gray",
                                            color: "black",
                                            width: matchesMobile
                                                ? "80%"
                                                : "40%",
                                            padding: "25px 0",
                                            marginTop: "20px",
                                            marginBottom: "50px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: 0,
                                            fontSize: "16px",
                                            fontFamily: "EurostilDemi",
                                        }}
                                        // disabled={true}
                                        disabled={
                                            address &&
                                            isConnected &&
                                            isChainSupported &&
                                            isBurnActive
                                                ? false
                                                : true
                                        }
                                        onClick={() => {
                                            // handleBurnValidator();
                                            setIsBurnModalOpen(true);
                                        }}
                                    >
                                        <span>
                                            {" "}
                                            Burn{" "}
                                            {address &&
                                            isConnected &&
                                            isChainSupported &&
                                            isBurnActive
                                                ? ""
                                                : "(Owner Only)"}{" "}
                                        </span>
                                    </Button>{" "}
                                </Grid>
                            </Grid>
                        </div>
                    )}
                </>
            </Grid>
        </Grid>
    );
};

export default Validator;
